import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { StripePaymentElement } from "@stripe/stripe-js";
import {
  Box,
  Button,
  Typography,
  Stack,
  CircularProgress,
} from "@mui/material";
import ResponseCard from "../displayDataComponents/wallet/ResponseCard";
import ByteChip from "../icons/ByteChip";
import RightIcon from "../icons/RightIcon";
import CancelIcon from "../icons/Cancel";

type CheckoutFormProps = {
  onReady?: (element: StripePaymentElement) => any;
  amount?: number;
};
const CheckoutForm: React.FC<CheckoutFormProps> = ({ onReady, amount }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState<string>();
  const [isReady, setIsReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [errorPay, setErrorPay] = useState(false);
  const [successPay, setSuccessPay] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>("");
  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    await stripe
      .confirmPayment({
        elements,
        redirect: "if_required", // Prevents unnecessary redirects
      })
      .then((res) => {
        const { paymentIntent, error } = res;
        if (error) {
          if (error.type !== "validation_error") {
            setErrorPay(true);
            setErrorMessage(error.message);
            setCurrentStep(1);
          }
        }
        if (paymentIntent?.status === "succeeded") {
          setSuccessPay(true);
          setCurrentStep(1);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setErrorPay(true);

        setIsLoading(false);
      });

    // const { error } = await stripe.confirmPayment({
    //   elements,
    //   confirmParams: {
    //     // Make sure to change this to your payment completion page
    //     return_url: window.location.origin + "/wallet", //"http://localhost:3000/wallet"
    //   },
    // });

    // // This point will only be reached if there is an immediate error when
    // // confirming the payment. Otherwise, your customer will be redirected to
    // // your `return_url`. For some payment methods like iDEAL, your customer will
    // // be redirected to an intermediate site first to authorize the payment, then
    // // redirected to the `return_url`.

    // // if (error.type === "card_error" || error.type === "validation_error") {
    // //     setMessage(error.message);
    // // } else {
    // //     setMessage("An unexpected error occurred.");
    // // }
  };

  return currentStep === 0 ? (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement
        id="payment-element"
        onReady={(element) => {
          onReady && onReady(element);
          setIsReady(true);
        }}
      />
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        my={2}
      >
        <Button
          color="primary"
          variant="contained"
          type="submit"
          disabled={isLoading || !stripe || !elements || !isReady}
          id="submit"
        >
          <span id="button-text">
            {isLoading ? <CircularProgress size={20} /> : "Pay now"}
          </span>
        </Button>
      </Box>
    </form>
  ) : (
    <>
      {successPay && (
        <ResponseCard
          title="Your purchase was successful!"
          icon={<RightIcon color="success" size="large" />}
          message={
            <>
              <Stack direction={"row"} columnGap={1} flexWrap={"wrap"}>
                <Typography>The amount of</Typography>
                <Stack direction={"row"} alignItems={"center"}>
                  <ByteChip size="xxs" />
                  <Typography>{amount}</Typography>
                </Stack>
                <Typography> will be added to your</Typography>
              </Stack>
              <Typography>
                balance shortly. You may close this modal.
              </Typography>
            </>
          }
        />
      )}
      {errorPay && (
        <ResponseCard
          title="Your purchase was unsuccessful"
          icon={<CancelIcon color="error" size="large" />}
          message={
            <>
              <Typography textAlign={"center"}>
                An error occurred while processing your payment.
              </Typography>
              {errorMessage && (
                <Typography textAlign={"center"}>[{errorMessage}]</Typography>
              )}
              <Typography textAlign={"center"}>
                Please try again or contact support if the issue persists. You
                may close this modal.
              </Typography>
            </>
          }
        />
      )}
    </>
  );
};

export default CheckoutForm;
